export var SystemRole;
(function (SystemRole) {
    SystemRole["ADMIN"] = "ADMIN";
    SystemRole["PLANNER"] = "PLANNER";
    SystemRole["CLIENT"] = "CLIENT";
    SystemRole["VENDOR"] = "VENDOR";
})(SystemRole || (SystemRole = {}));
//# sourceMappingURL=user.js.map